import { render } from "./AIAgentSettings.vue?vue&type=template&id=1e038e46&scoped=true"
import script from "./AIAgentSettings.vue?vue&type=script&lang=js"
export * from "./AIAgentSettings.vue?vue&type=script&lang=js"

import "./AIAgentSettings.vue?vue&type=style&index=0&id=1e038e46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e038e46"]])

export default __exports__